import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  Pager,
  Paging,
  Button2,
} from "devextreme-react/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { api_path } from "../../shared.js";
function SubContactForm(props) {
     const [modeSize, setModeSize] = useState('widget');
            const pageSizes = [25, 50, 100];
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
      };
    const [CustomerCode, setCustomerCode] = useState();
    const [ContactName, setContactName] = useState();
    const [ContactPhone, setContactPhone] = useState();
    useEffect( ()=>{
      if (props.CUSTOMER_CODE > 0) {
        fetch(api_path + "/MS_CUS_CONTACT.php?CUSTOMER_CODE=" + props.CUSTOMER_CODE + "&PROFILE_TYPE=" + props.PROFILE_TYPE)
          .then((res) => res.json())
          .then((res) => {
            //console.log(res);
            const array = res;
            for (const i of array) {
              setCustomerCode(i.CRM_CUSCODE);
              setContactName(i.CONTACT_NAME);
              setContactPhone(i.TEL);
            }
          });

        //setDisabled(false);
      } else {
       // setDisabled(true);
      }
  },[props.CUSTOMER_CODE]);
    const handleSubmit = (event) => {
        let id = 0;
        let USERID = "kornraphat.c@sinologistics.co.th";
        event.preventDefault();
        let methodKey = "";
        if (id > 0) {
          methodKey = "PUT";
          var data = {
            CustomerCode: CustomerCode,
            ContactName: ContactName,
            ContactPhone: ContactPhone,
          };
        } else {
          methodKey = "POST";
          var data = {
            CustomerCode: CustomerCode,
            ContactName: ContactName,
            ContactPhone: ContactPhone,
          };
        }
        fetch(api_path + "/CT_QUOTATION.php", {
          method: methodKey,
          headers: {
            Accept: "application/form-data",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((result) => {
            if (result["status"] == "200") {
              swal("Done.", "Save data successfully.", "success", {
                buttons: true,
                timer: 1000,
              }).then(function () {
                //window.location = "./#/SaleInquiry?id=" + result["message"] + "&country_code=" +selectCountry;
              });
            } else {
              swal("Sorry", result["message"], "error", {
                buttons: true,
                timer: 1000,
              });
            }
          });
      };
       const url =
     api_path + "/MS_SERVICE_CONTRACT.php?CARRIER=" + props.CARRIER_CODE;
   const dataSource = createStore({
     key: "SERVICE_CONTRACT_ID",
     loadUrl: `${url}`,
   });
    const url2 =
     api_path + "/GET_LAST_SHIPMENT.php?CUSTOMER_PARENT_CODE=" + props.CARRIER_CODE;
   const dataSource2 = createStore({
     key: "SERVICE_CONTRACT_ID",
     loadUrl: `${url2}`,
   });
 const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG === "2") {
        e.cellElement.style.cssText = "color: red;font-weight:normal;";
      }else if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG === "3") {
        e.cellElement.style.cssText = "color: red;font-weight:normal;";
      // } else if (e.column.dataField === "VALID" && e.data.VALID === "Invalid") {
      //   e.cellElement.style.cssText = "color: #ff6f4a;font-weight:bold;";
      }
    }
  };
  return (
         <Grid item xs={12} sm={6}>
         <label className="head2">Sales InCharge</label>
              <DataGrid
              onCellPrepared={cellPrepared}
              dataSource={dataSource}
              showBorders={true}
              columnAutoWidth={true}
              rowAlternationEnabled={false}
              allowColumnReordering={true}
              allowColumnResizing={true}
              columnResizingMode={modeSize}
              columnMinWidth={50}
              showScrollbar={true}
              keyExpr="SERVICE_CONTRACT_ID"
           
            >
              <Scrolling
                rowRenderingMode="virtual"
                showScrollbar="always"
                useNative="false"
                scrollByThumb="true"
              ></Scrolling>
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter visible={true} />
           
              <Column dataField="TRADE_LANE" caption="EMP CODE" />
              <Column dataField="CARRIER_CODE" caption="SALES NAMES" />
            
              <Column
                dataField="SERVICE_CONTRACT_NO"
                caption="TIER"
              />
              <Column dataField="BULLET_CODE" caption="STATUS" />
           
              <Column dataField="CONDITION" caption="REASON" />
             

              <LoadPanel enabled={true} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
              <Paging defaultPageSize={25} />
            </DataGrid>
           <br/><br/>
        <label className="head2">Last 10 Shipment of Customer</label>
            <DataGrid
              onCellPrepared={cellPrepared}
              dataSource={dataSource2}
              showBorders={true}
              columnAutoWidth={true}
              rowAlternationEnabled={false}
              allowColumnReordering={true}
              allowColumnResizing={true}
              columnResizingMode={modeSize}
              columnMinWidth={50}
              showScrollbar={true}
              keyExpr="SERVICE_CONTRACT_ID"
           
            >
              <Scrolling
                rowRenderingMode="virtual"
                showScrollbar="always"
                useNative="false"
                scrollByThumb="true"
              ></Scrolling>
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter visible={true} />
           
              <Column dataField="TRADE_LANE" caption="DOC NO"/>
              <Column dataField="CARRIER_CODE" caption="JOB NO" />
            
              <Column
                dataField="SERVICE_CONTRACT_NO"
                caption="SALES"
              />
              <Column dataField="BULLET_CODE" caption="CUSTOMER CODE" />
              <Column dataField="CONDITION" caption="CUSTOMER" />
             

              <LoadPanel enabled={true} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
              <Paging defaultPageSize={25} />
            </DataGrid>
          {/* <form onSubmit={handleSubmit}>
             
                <Grid container className="Box" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <label>CONTACT NAME</label>
                    <span className="red">*</span>
                    <TextField
                      size="small"
                      name="ContactName"
                      variant="outlined"
                      required
                      fullWidth
                      id="ContactName"
                      value={ContactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <label>CONTACT PHONE</label>
                    <TextField
                      size="small"
                      name="ContactPhone"
                      variant="outlined"
                      required
                      fullWidth
                      id="ContactPhone"
                      value={ContactPhone}
                      onChange={(e) => setContactPhone(e.target.value)}
                    />
                  </Grid>
                
               

                  <br />
                  <Grid container className="Box" spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                      >
                        Save
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        type="button"
                        fullWidth
                        variant="outlined"
                        color="primary"
                        onClick={goBack}
                      >
                        &larr; Go Back
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </form> */}
           
    </Grid>
  )
}

export default SubContactForm